// extracted by mini-css-extract-plugin
export default {"pageLoadingIndicatorContainer":"PageLoadingIndicator_pageLoadingIndicatorContainer__fM1Xd","imageMessage":"PageLoadingIndicator_imageMessage__64ZHT"};